module.exports = __webpack_public_path__ + "img/swap-up.1983df1f.svg";